"use strict";
/**
 *  docDetailModule
 *
 * Description 策划中心 实时线索 计划性线索 监测跟踪 稿件详情
 * Author Qian.qianchen 2019-06-18
 */
angular.module('docDetailModule', [])
    .controller('docDetailCtrl', ["$scope", "$state", "trsHttpService", "trsspliceString", "modalDialog",
        function($scope, $state, trsHttpService, trsspliceString, modalDialog) {
            initStatus();
            getData();

            function initStatus() {
                let resoucetype = {
                    1: "相关热点",
                    2: "相关政策",
                    3: "内部报道",
                    4: "一级媒体报道",
                    5: "关键词",
                    6: "关联稿件",
                    7: "关联图片",
                    8: "地区关联稿件",
                    9: "情感词",
                };
                if ($state.params.resoucetype == 8) {
                    resoucetype[8] = $state.params.areaname + '相关稿件';
                }
                if ($state.params.resoucetype == 9) {
                    resoucetype[9] = '-' + $state.params.cloudword + '情感词报导稿件';
                }
                if ($state.params.resoucetype == 5) {
                    resoucetype[5] = '-' + $state.params.cloudword + '关键词报导稿件';
                }
                $scope.data = {
                    docList: [],
                    trackname: '“' + $state.params.trackname + '”',
                    resoucetype: resoucetype[$state.params.resoucetype],
                    hotLists: {
                        page: {
                            "pn": 0,
                            "PAGESIZE": 20,
                            "ITEMCOUNT": 0,
                            "startpage": 0
                        },
                        status: {
                            "jumpToPageNum": 1,
                            "startpage": 0
                        }
                    },
                };
                $scope.params = {
                    "serviceid": 'monitortrack',
                    "modelid": 'trackDetail',
                    "id": $state.params.trackid,
                    "type": $state.params.resoucetype,
                    "page_no": $scope.data.hotLists.page.startpage,
                    "page_size": $scope.data.hotLists.page.PAGESIZE,
                };
                if ($state.params.resoucetype == 8) {
                    $scope.params.area = $state.params.areacode;
                }
                if ($state.params.resoucetype == 5 || $state.params.resoucetype == 9) {
                    $scope.params.keywords = $state.params.cloudword;
                }
            }
            /**
             * [getData description]数据请求函数(稿件数据分页获取)
             * @return {[obj]} [description]
             */
            function getData() {
                $scope.params.page_no = $scope.data.hotLists.page.startpage;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "get").then(function(data) {
                    $scope.data.docList = data.list.PAGEITEMS || [];
                    $scope.data.hotLists.page.pn = data.list.STARTPAGE + 1;
                    $scope.data.hotLists.page.PAGESIZE = data.list.PAGESIZE;
                    $scope.data.hotLists.page.ITEMCOUNT = data.list.TOTALITEMCOUNT;
                    $scope.data.hotLists.page.PAGECOUNT = data.list.TOTALPAGECOUNT;
                });
            }
            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.data.hotLists.status.jumpToPageNum = $scope.data.hotLists.page.pn;
                $scope.data.hotLists.page.startpage = $scope.data.hotLists.page.pn - 1;
                getData();
            };
            $scope.jumpToPage = function() {
                if ($scope.data.hotLists.status.jumpToPageNum > $scope.data.hotLists.page.PAGECOUNT) {
                    $scope.data.hotLists.status.jumpToPageNum = $scope.data.hotLists.page.PAGECOUNT;
                }
                if ($scope.data.hotLists.status.jumpToPageNum === "0" || isNaN(Number($scope.data.hotLists.status.jumpToPageNum))) {
                    modalDialog.alertType("请输入合法的页码", "", "warning", false);
                    return;
                }
                $scope.data.hotLists.page.startpage = $scope.data.hotLists.status.jumpToPageNum - 1;
                getData();
            };
            /**
             * [goBack description] 返回上一页
             */
            $scope.goBack = function() {
                window.history.go(-1)
            };
            /**
             * [linkFormat description] 稿件详情跳转
             * @param  {[type]} articleItem [description] 稿件
             * @return {[type]}      [description]
             */
            $scope.linkFormat = function(articleItem) {
                if ($state.params.resoucetype == 1) {
                    return 0;
                }
                if (articleItem.TYPE == "xhsg") {
                    return 'resourcexhsgbigdatadetail({guid:articleItem.GUID,indexname:articleItem.INDEXNAME})';
                }
                return 'resourcedetail({guid:articleItem.GUID,indexname:articleItem.INDEXNAME})';
            }
        }
    ]);